import {
  Box,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { READABLE_RSVP_RESPONSES } from '@/components/RsvpList/utils';
import { SelectButton } from '@/components/SelectButton';
import { ERsvpResponse } from '@/graphql-types/globalTypes';
import {
  CheckCircleIcon,
  HelpCircleIcon,
  XCircleIcon,
} from '@/imports/ui/chakra/feather';

export const RsvpSelect: React.FC<{
  value?: ERsvpResponse;
  onChange: (value: ERsvpResponse) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}> = ({ value, onChange, isLoading, isDisabled }) => {
  return (
    <Box>
      <Menu>
        <MenuButton
          as={SelectButton}
          leftIcon={value ? <RsvpIcon response={value} /> : undefined}
          isLoading={isLoading}
          isDisabled={isDisabled}
        >
          {value ? READABLE_RSVP_RESPONSES[value] : 'RSVP'}
        </MenuButton>
        <MenuList>
          <MenuOptionGroup value={value} onChange={onChange} type="radio">
            <MenuItemOption value={ERsvpResponse.GOING}>
              {READABLE_RSVP_RESPONSES[ERsvpResponse.GOING]}
            </MenuItemOption>
            <MenuItemOption value={ERsvpResponse.MAYBE}>
              {READABLE_RSVP_RESPONSES[ERsvpResponse.MAYBE]}
            </MenuItemOption>
            <MenuItemOption value={ERsvpResponse.NOT_GOING}>
              {READABLE_RSVP_RESPONSES[ERsvpResponse.NOT_GOING]}
            </MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};

export const RsvpIcon: React.FC<{ response: ERsvpResponse }> = ({
  response,
}) => {
  switch (response) {
    case ERsvpResponse.GOING:
      return <CheckCircleIcon color="primary.500" />;
    case ERsvpResponse.MAYBE:
      return <HelpCircleIcon />;
    case ERsvpResponse.NOT_GOING:
      return <XCircleIcon />;
    default:
      return null;
  }
};
